<template>
  <section>
    <b-row>
      <b-col cols="2" v-if="!isRma">
        <b-form-group label="Report Type" >
          <b-form-select
            v-model="inspectionReportTypeId"
          >
            <option value="344">Aegis Inspection</option>
            <option value="345">IDEA Inspection</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <div class="buttons-panel">
        <b-button size="sm" class="mr-2" variant="primary" :disabled="isSaving" @click="onSubmit(false)">
          <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i><i class="fa fa-plus mr-1"></i>Add New
        </b-button>
        <b-button size="sm" class="mr-2" variant="primary" :disabled="isSaving" @click="onSubmit(true)">
          <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i><i class="fa fa-edit mr-1"></i>Add New & Open
        </b-button>
      </div>
    </b-row>
      <b-modal
        id="manage-poreport-modal"
        ref="manage-poreport-modal"
        size="xl"
        hide-footer
        header-close-label="Cancel"
        :title="`Manage Report - ${inspectionReportTypeName}`"
        scrollable
      >
        <AddFormWizard :reportName="reportName" :inventoryDetails="{...lineData,quantitySold: (!this.isRma) ? lineData.quantity : lineData.qtyReturning}" :inspectionDetails="inspectionDetails" @getReports="getReports(false)" :onRmaInspection="isRma" />
      </b-modal>
    <grid-component
      class="mt-2"
      :itemData="itemData"
      :fields="gridFields"
      :gridId="gridId"
      :onDelete="onDelete"
      :handleRowClick="onEdit"
    />
  </section>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  import { InspectionReportDto, InspectionReport } from '@/pages/InspectionReports/dto';
  import {FIELDS}  from '@/pages/InspectionReports/constants'
  import gridFields from '../../fields';
  import {GRID_ID} from '@/shared/constants';
  import GridComponent from '@/shared/components/GridComponent';
  import AddFormWizard from './AddFormWizard';

  export default {
    name: 'myFormWizard',
    components: {
      GridComponent,
      AddFormWizard,
    },
    props: {
      lineData: {
        type: [Object],
        default: {},
      },
      isRma: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dataItem: InspectionReport,
        inspectionDetails: {},
        inspectionReportTypeId: '344',
        FIELDS:FIELDS,
        isSaving: false,
        gridFields,
        gridId: GRID_ID.INSPECTION_REPORTS_FORM,
        selectedRowItemId:0,
        inspectionReportTypeName:'',
        reportName:'',
        tmpData: {},
      };
    },
    validations: {
      dataItem: {
        id: {},
        purchaseOrderLineId: {},
        salesOrderLineId: {},
        dateInspected: {},
        inspectedByUserId: {},
        statusId: {},
        inventoryId: {},
        ordered: {},
        orderDetailShippingPayMethod: {},
        orderDetailCodAmount: {},
      },
    },
    computed: {
      ...mapGetters('inspectionReports', ['inspectionReportsListByPoLine', 'inspectionReportsListByInventory', 'rmaInspectionReportsList']),
      ...mapGetters('account', ['userId']),
      itemData() {
        const inspectionReportList = (this.isRma) ? this.rmaInspectionReportsList : this.inspectionReportsListByPoLine;

        return inspectionReportList.map((inspectionReportsList) => ({ ...inspectionReportsList, selected: inspectionReportList.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapActions('inspectionReports', ['getInspectionByPurchaseOrderLine','getRmaInspection','createInspectionReport','deleteInspectionReport', 'getInspectionByInventory']),
      async onSubmit(isEdit=false) {
        this.$v.dataItem.$touch();
        if (this.$v.dataItem.$invalid) {
          return;
        }
        let payload = new InspectionReportDto(this.dataItem);
        payload.id = 0; //New records will start with an id of zero
        payload.active = true; //New records will always be true
        payload.rmaLineId = (this.isRma) ? this.lineData.id : 0;
        payload.purchaseOrderLineId = (!this.isRma) ? this.lineData.id : 0;
        payload.inspectionReportTypeId = (!this.isRma) ? this.inspectionReportTypeId : '448';
        payload.salesOrderLineId = this.lineData.salesOrderLineId || 0;
        payload.dateInspected = new Date().toISOString();
        payload.inspectedByUserId = this.userId;
        payload.statusId = 0;
        payload.inventoryId = this.lineData.inventoryId || 0;
        payload.ordered = this.lineData.ordered || 0;
        payload.productDetails_Received = this.lineData.productDetails_Received || 0;
        payload.productDetails_Stock = this.lineData.productDetails_Stock || 0;

        try {
          this.isSaving=true;
          let resData = await this.createInspectionReport(payload);
          this.isSaving = false;
          if(resData.id && isEdit) {
            /*this.onEdit(resData)*/
            this.$emit('createdInspection');
            this.onEdit({dataItem:resData})
          }
          this.getReports(false);
        } catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      },
      onEdit({ dataItem }){
        this.inspectionReportTypeName = (!this.isRma) ? (dataItem.inspectionReportTypeName=='Default') ? 'Aegis Inspection' : 'IDEA Inspection' : 'RMA Inspection';
        this.reportName = (!this.isRma) ? (dataItem.inspectionReportTypeName=='Default') ? 'DefaultInspection' : 'IdeaInspection' : 'RmaInspection';
        this.selectedRowItemId = dataItem.id;
        this.inspectionDetails =dataItem;
        this.$bvModal.show('manage-poreport-modal');
      },
      async onDelete({id}) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
          await this.deleteInspectionReport(id);
          this.getReports();
        }
      },
      async getReports(isClose = true) {
        if (isClose) {
          this.$bvModal.hide('manage-poreport-modal');
        }
        console.log(this.lineData,'line Data from Inventory details')
        if (this.lineData.id) {
          if (!this.isRma) {
            await this.getInspectionByPurchaseOrderLine(this.lineData.id);
          } else {
            await this.getRmaInspection(this.lineData.id);
          }
        }
      },
    },
    watch: {
      lineData() {
        this.getReports();
      }
    },
    mounted() {
     this.getReports();
    }
  };
</script>

<style lang="scss">
  .vue-form-wizard {
    width: 100%;
  }
  .wizard-tab-content {
    padding: 15px 20px 10px;
  }
  .col-form-label {
    font-size: 100%;
  }
</style>
